export default __webpack_public_path__ + "static/banner-519457a762af5cf0ece7723fbf22e971.png";